import { faSearch } from "@jewlr/pro-light-svg-icons/faSearch"
import Cookies from "js-cookie"
import PropTypes from "prop-types"
import { useEffect, useRef, useState } from "react"
import { useDispatch } from "react-redux"
import { Link, useLocation } from "react-router-dom"

import {
  clearSearchUserInput,
  clearSearchSuggestions,
} from "app-store-v2/app/actions"
import CartIcon from "areas/header/dropdowns/cart-icon"
import withHeader from "areas/header/hoc/with-header"
import NavIcon from "areas/header/nav-icon"
import HeaderSearch from "areas/header/portal/search/search"
import WishlistIcon from "areas/header/portal/wishlist-icon"
import Button from "components/ui/button"
import Image from "components/ui/image"
import Media from "components/ui/media"
import { cn } from "styles/utils"

const MobileHeader = ({ showMenu, toggleMenu }) => {
  const [searching, setSearch] = useState(false)
  const [geo, setGeo] = useState(null)
  const searchInputRef = useRef()
  const searchBtnRef = useRef()
  const restoreSearchFocus = useRef()

  const location = useLocation()
  const dispatch = useDispatch()
  const clearSearch = () => {
    dispatch(clearSearchUserInput())
    dispatch(clearSearchSuggestions())
  }

  useEffect(() => {
    toggleMenu(true)
    setSearch(false)
    clearSearch()
  }, [location.pathname])

  useEffect(() => {
    setGeo(Cookies.get("geo"))
  }, [geo])

  useEffect(() => {
    if (!searching && restoreSearchFocus.current && searchBtnRef.current) {
      searchBtnRef.current.focus()
      restoreSearchFocus.current = false
    }
  }, [searching, searchBtnRef.current])

  const toggleSearchBar = (e) => {
    e.preventDefault()
    setSearch(!searching)
    toggleMenu(true)
  }

  const handleCloseSearch = () => {
    restoreSearchFocus.current = true
    setSearch(false)
  }

  return (
    <Media
      className="h-(--mobile-header-height) relative flex w-full"
      lessThan="desktop"
    >
      {searching ? (
        <div className="flex items-center">
          <HeaderSearch
            handleCloseSearch={handleCloseSearch}
            searchInputRef={searchInputRef}
          />
        </div>
      ) : (
        <div className="flex w-full items-center justify-between px-16">
          <div className="flex items-center">
            <Link className="block" data-lc="home" to="/">
              <Image
                alt={sl.config.site_title}
                height="36"
                lazyload={false}
                src={require("images/logo/customize-your-jewelry-logo.svg")}
                width="141"
              />
            </Link>
          </div>
          <div className="grow-1 flex items-center justify-end">
            <div className="tablet:gap-24 mr-24 flex items-center gap-20">
              <Button
                aria-label="Search"
                data-cy="header-mobile-search-icon"
                onClick={(e) => toggleSearchBar(e)}
                ref={searchBtnRef}
              >
                <NavIcon icon={faSearch} />
              </Button>
              <WishlistIcon />
              <CartIcon isMobile />
            </div>

            <Button
              aria-controls="mobile-menu"
              aria-expanded={showMenu}
              aria-haspopup="true"
              aria-label="Menu"
              className="h-22 w-20 bg-white"
              data-cy="header-menu-icon-mobile"
              id="js_menu_toggle"
              onClick={() => toggleMenu(showMenu)}
            >
              <div
                className={cn(
                  "absolute block h-2 w-20 bg-black transition duration-200",
                  "before:absolute before:-top-7 before:block before:h-2 before:w-20 before:bg-black before:transition before:duration-200",
                  "after:absolute after:top-7 after:block after:h-2 after:w-20 after:bg-black after:transition after:duration-200",
                  showMenu && "bg-transparent",
                  showMenu && "before:top-0 before:rotate-45",
                  showMenu && "after:top-0 after:-rotate-45"
                )}
              />
            </Button>
          </div>
        </div>
      )}
    </Media>
  )
}

MobileHeader.propTypes = {
  showMenu: PropTypes.bool,
  toggleMenu: PropTypes.func,
}

export default withHeader(MobileHeader)
